import firebase from 'firebase'
import { getStoreBuilder, BareActionContext } from 'vuex-typex'
import { RootState } from "@/types"
import { ProfileState, ProfileStore, Profile } from "./types"
import { Store } from "vuex"
import { authService } from "@/auth/service"
import { RMUser } from "@/auth/api"

export {
  profileStore,
  reactions,
}

const b = getStoreBuilder<RootState>()
  .module<ProfileState>('profile', {
    status: "idle",
    profile: null
  })
const stateGetter = b.state()
const profileStore: ProfileStore = {
  // state
  get state() { return stateGetter() },

  // Load Profile
  load: b.dispatch(load),
  update: b.dispatch(update),
  clear: b.commit(clear)
}

function clear(state: ProfileState) {
  state.profile = null
}

async function update(
  context: BareActionContext<ProfileState, RootState>,
  profile: Profile
) {
  context.state.status = "updating"
  try {
    const ref = firebase.firestore().collection('profiles').doc(profile.user.uid)
    // basically underscore.omit(profile,["user"])
    // not worth a dependency
    const data = (({ user, ...otherFields }) => otherFields)(profile)
    await ref.set(data)
    context.state.profile = profile
    context.state.status = "idle"
  } catch (error) {
    context.state.status = "idle"
    console.log("error")
    throw new Error(error);
  }

}

async function load(
  context: BareActionContext<ProfileState, RootState>,
  user: RMUser) {
  context.state.status = "loading"
  let ref = firebase.firestore().collection('profiles').doc(user.uid)

  try {
    const doc = await ref.get()
    if (doc.exists) {
      let data = doc.data() as Profile
      let profile: Profile = {
        ...data,
        user: user
      }
      console.log("profile", profile)
      context.state.profile = profile;
    } else {
      console.warn("User profile not found")
      // normally a profile is created when user creates an account
      // in this case it's not, we should maybe create one here with defaults
      context.state.profile = {
        name: "",
        dob: "",
        phone: "",
        address: "",
        city: "",
        country: "",
        postalCode: "",
        autoInvest: false,
        user: user
      }
    }
    context.state.status = "idle"
  } catch (error) {
    context.state.status = "idle"
    console.error(error)
    throw new Error(error);
  }
}



function reactions() {
  const auth = authService()
  auth.user.subscribe((u) => {
    console.log("ddd", u)
    if (u == null) {
      return profileStore.clear()
    } else {
      profileStore.load(u)
    }

  })

}

